export const ROUTES = {
  LOGIN: '/doctor/login',
  DOCTOR_DASHBOARD: '/doctor/dashboard',
  MANAGE_SESSIONS: '/doctor/sessions/manage',
  SESSION_VIEW: '/doctor/sessions/view',
  MEETING: '/doctor/meetings',
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_REGISTRATION: '/admin/registration',
  SUPER_ADMIN_DASHBOARD: '/super-admin/dashboard',
  PROFILE: '/profile',
  CLINIC_PROFILE: '/clinic/profile',
  CLINIC_ADMINISTRATION: '/clinic/administration',
  VERIFY_EMAIL: '/verify-email',
  FORGOT_PASSWORD: '/forgot-password',
  TEST_WORKFLOW: '/test/workflow',
  TKR_PATHWAY: '/doctor/tkr-pathway/:episodeId',
  TKR_DASHBOARD: '/doctor/tkr-dashboard',
  TKR_EPISODE: '/doctor/tkr-episode/:episodeId',
  TKR_1B_VISIT: '/doctor/tkr-episode/:episodeId/1B/visit/:visitType',
  TKR_SDM: '/doctor/tkr-pathway/:episodeId/sdm',
  VBC_DASHBOARD: '/doctor/vbc-dashboard',
} as const;
